import moment from 'moment';
export default {
	resultList: [],
	detailList: [],
	graphList: [],
	partGCdList: [],
	occuPlCdList: [],
	maxCnt: 0,
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO()
};

function SEARCH_PARAMS() {
	return {
		strDt: moment().format('YYYY'),
		period: 'month',
		partNo: '',
		partNm: '',
		partGCd: '',
		occuPlCd: '',
		cofCd: ''
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}
export { SEARCH_PARAMS, PAGING_INFO };
